module.exports = {
  handle: (e, data) => {   
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
          event: 'applicationAbandoned',
          applicationAbandonField: data.fieldName || 'n/a'
      });
  }
}